import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Heart, Calendar, Truck } from 'lucide-react';

interface VolunteerRole {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const VOLUNTEER_ROLES: VolunteerRole[] = [
  {
    icon: <Heart className="w-[2em] h-[2em] text-accessible-red-600" />,
    title: "Opieka nad zwierzętami",
    description: "Pomóż w codziennej opiece nad naszymi podopiecznymi."
  },
  {
    icon: <Calendar className="w-[2em] h-[2em] text-accessible-red-600" />,
    title: "Organizacja wydarzeń",
    description: "Wspieraj nas w organizacji dni otwartych i akcji adopcyjnych."
  },
  {
    icon: <Truck className="w-[2em] h-[2em] text-accessible-red-600" />,
    title: "Transport",
    description: "Pomagaj w transporcie zwierząt do weterynarza lub nowego domu."
  },
  {
    icon: <Users className="w-[2em] h-[2em] text-accessible-red-600" />,
    title: "Media społecznościowe",
    description: "Prowadź nasze profile w mediach społecznościowych."
  }
];

export function VolunteerCTA() {
  return (
    <section className="py-16 px-12 bg-gray-50 dark:bg-gray-800 high-contrast:bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="heading-2">
            Zostań wolontariuszem
          </h2>
          <p className="body-large max-w-2xl mx-auto">
            Dołącz do naszego zespołu i pomagaj zwierzętom w potrzebie. Każda para rąk się przyda!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {VOLUNTEER_ROLES.map((role, index) => (
            <div key={index} className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group">
              <div className="mb-4" aria-hidden="true">{role.icon}</div>
              <h3 className="heading-4 tight-spacing text-accessible-gray-900 dark:text-white high-contrast:text-white">
                {role.title}
              </h3>
              <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
                {role.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/wolontariat"
            className="bg-accessible-red-600 text-white px-8 py-4 rounded-lg btn-text-large hover:bg-accessible-red-700 transition-colors shadow-lg transform hover:scale-105 duration-300"
            aria-label="Dowiedz się więcej o wolontariacie"
          >
            Dołącz do nas
          </Link>
        </div>
      </div>
    </section>
  );
}